


















































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
  },
})
export default class CreateTicketModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // // @ts-ignore
  // @Prop({required: true, default: null}) readonly public lead: any;
  public linkedUser: any = null;
  public type: any = null;
  public text: any = '';
  public consultantsGroups: any = [];
  public formError: boolean = false;
  public usersToLink: any = [];
  public loadingState = {
    submit: false,
  };

  public mounted() {
    // this.getUsersToLink();
    
    let newList: any = [];
    for (let i in this.consultantsGroupsList) {
      newList.push(this.consultantsGroupsList[i].value);
    }
    this.consultantsGroups = newList;
  }

  public resetForm() {
    this.linkedUser = null;
    this.type = null;
    this.consultantsGroups = [];
    this.text = '';
    this.$emit('close-modal');
  }

  public validateForm() {
    if (!this.linkedUser || !this.type) {
      this.formError = true;
      return false;
    } else {
      this.formError = false;
      return true;
    }
  }

  public async handleSubmit() {
    if (await this.validateForm()) {
      try {
        const response = await api.createTicketByConsultant(
          this.$store.getters.token,
          {
            user: this.linkedUser, type: this.type, text: this.text, consultants_groups: this.consultantsGroups,
          },
        );
        // @ts-ignore
        this.showToast(this, this.$t('Ticket created'));
        this.$emit('created-event');
        this.resetForm();
      } catch (error) {
        // @ts-ignore
        if (error.response && error.response.data) {
          let errorMsg = '';
          // @ts-ignore
          for (const [key, value] of Object.entries(error.response.data)) {
            // @ts-ignore
            errorMsg += `${this.$t(key)} - ${value[0]}\n`;
          }
          // @ts-ignore
          this.showToast(this, errorMsg, 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
    }
  }

  // public async getUsersToLink() {
  //   try {
  //     const response = await api.getUsersToLink(this.$store.getters.token);
  //     const usersToLink: any = [];
  //     for (const [key, value] of Object.entries(response.data)) {
  //       usersToLink.push({
  //         // @ts-ignore
  //         value: value[0],
  //         // @ts-ignore
  //         text: `${value[1]} ${value[2]}`,
  //       });
  //     }
  //     this.usersToLink = usersToLink;
  //   } catch (e) {
  //     this.usersToLink = [];
  //   }
  // }

  public handleChangeType(value) {
    this.type = value;
  }

  public handleChangeLinkedUser(value) {
    this.linkedUser = value;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get userGroupType() {
    const groups = [
      "Руководитель отдела консультирования",
      "Менеджер отдела консультирования",
      "Консультант отдела консультирования",
      "Администратор отдела консультирования",
    ];
    let group = 'partner';
    if (this.userProfile) {
      if (this.userProfile.groups.includes('Админы')) {
        group = 'admin';
      } else {
        for (const [key, value] of Object.entries(groups)) {
          // @ts-ignore
          if (this.userProfile.groups.includes(value)) {
            group = 'consultant';
          }
        }
      }
    } else {
      group = '';
    }
    return group;
  }

  get consultantsGroupsList() {
    const group = this.userGroupType;
    if (group === 'partner') {
      return [
        {
          value: 16,
          text: 'Руководитель отдела консультирования',
        },
        {
          value: 18,
          text: 'Администратор отдела консультирования',
        },
        {
          value: 20,
          text: 'Менеджер отдела консультирования',
        },
        {
          value: 21,
          text: 'Консультант отдела консультирования',
        },
      ];
    } else if (group === 'consultant') {
      return [
        {
          value: 15,
          text: 'Руководитель партнерского отдела',
        },
        {
          value: 17,
          text: 'Администратор партнерского отдела',
        },
        {
          value: 19,
          text: 'Менеджер партнерского отдела',
        },
        {
          value: 22,
          text: 'Консультант партнерского отдела',
        },
      ];
    } else if (group === 'admin') {
      return [
        {
          value: 15,
          text: 'Руководитель партнерского отдела',
        },
        {
          value: 16,
          text: 'Руководитель отдела консультирования',
        },
        {
          value: 17,
          text: 'Администратор партнерского отдела',
        },
        {
          value: 18,
          text: 'Администратор отдела консультирования',
        },
        {
          value: 19,
          text: 'Менеджер партнерского отдела',
        },
        {
          value: 20,
          text: 'Менеджер отдела консультирования',
        },
        {
          value: 22,
          text: 'Консультант партнерского отдела',
        },
        {
          value: 21,
          text: 'Консультант отдела консультирования',
        },
      ];
    }

    return [];
  }
}
